import {NgModule} from "@angular/core";
import {ToastService} from "@app/presentation/services/toast/toast.service";
import {ToastComponent} from "@app/presentation/services/toast/toast.component";
import {AngularSvgIconModule} from "angular-svg-icon";
import {CommonModule} from "@angular/common";
import {TranslateModule} from "@ngx-translate/core";
import {ToastrModule} from "ngx-toastr";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';


@NgModule({
    declarations: [
        ToastComponent,
    ],
    imports: [
        AngularSvgIconModule,
        CommonModule,
        TranslateModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            maxOpened: 1,
            preventDuplicates: true,
        }),
    ],
    providers: [
        ToastService,
    ],
})
export class ToastModule {}
